<template>
  <div class="background-03">

    <v-layout row wrap>
      <v-flex xs12 sm2 md2 class="hidden-xs-only ">
        <image-app class="animated fadeInLeft" :imaSize="300" imaSrc="design/banco1-1-3" imaAlt=""></image-app>
      </v-flex>
      <v-flex xs12 sm9 class="animated fadeInUp dura_1">
        <ui-title-one titleAccess="¿Qué es el Patrimonio:?" titleLevel="h1">
          <template slot="partOne">¿Qué es el <br></template>
          <!-- <template slot="partTwo"></template> -->
          <template slot="partThree"> patrimonio?</template>
        </ui-title-one>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc  :vidTittle="'¿Qué es el patrimonio?'" videoEmbed="ADMINISTRACIONDINERO45QueEsPatrimonio.mp4"></ui-simple-lsc>
      </v-flex>
      <v-flex xs12 sm5 md5 text-xs-center class="aligner animated fadeIn dura_2">
        <image-app :imaSize="300" imaSrc="contenido/diapositiva_46" imaAlt="Mujer explicando el concepto"></image-app>
      </v-flex>
      <v-flex xs12 md6 class="animated fadeInUp dura_2 aligner">
        <p class="text-box adorn-bottom">
          El patrimonio se define como el <strong>conjunto de dinero</strong>, inversiones y bienes tangibles que componen la 
          riqueza de una persona. Se obtiene de <strong>tomar los activos y restarle los pasivos</strong>;
           es decir sumar los bienes, inversiones y dinero, y restar las deudas.
           <audio-player ref="audioPlayer" :autoplay="true" :audios="[
            'Administracion6.mp3'
            ]"></audio-player>
        </p>
      </v-flex>
    </v-layout>

  </div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.$store.commit("nextShow", true);
  }
};
</script>


// WEBPACK FOOTER //
// davivienda-45.vue?040e3b91